import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { HomeOneComponent } from './components/pages/home-one/home-one.component'
import { BlogPageComponent } from './components/pages/blog-page/blog-page.component'
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component'
import { SellerDescriptionComponent } from './components/pages/seller-description/seller-description.component'
import { BuyerDescriptionComponent } from './components/pages/buyer-description/buyer-description.component'
import { TransporterDescriptionComponent } from './components/pages/transporter-description/transporter-description.component'
import { JoinUsComponent } from './components/pages/join-us/join-us.component'
import { AlternativeServiceComponent } from './components/pages/alternative-service/alternative-service.component'
import { RulesComponent } from './components/pages/rules/rules.component'
import { NgxSeo } from '@avivharuzi/ngx-seo'

const SEO_BLOG: NgxSeo = {
  title: 'مدونة الزراعة',
  meta: {
    description:
      'تابع أحدث المقالات حول تجارة الخضار والفواكه بالجملة، وأساليب التحسين في القطاع الزراعي، بالإضافة إلى نصائح حول الحصول على أفضل المنتجات والخدمات المساندة.',
  },
}

const SEO_BUYER: NgxSeo = {
  title: ' المشتري',
  meta: {
    description:
      'منصة موثوقة لشراء الخضار والفواكه بالجملة بأسعار تنافسية، مع خدمات نقل متطورة تضمن وصول المنتجات بكفاءة وجودة عالية، بدعم رؤية 2030.',
  },
}

const SEO_SELLER: NgxSeo = {
  title: ' البائع',
  meta: {
    description:
      'عرض وبيع الخضار والفواكه بالجملة عبر منصة سعودية موثوقة، مع الاستفادة من خدمات النقل المتطورة التي تضمن تسليم المنتجات بجودة عالية، وذلك لدعم رؤية 2030.',
  },
}

const SEO_TRANSPORTER: NgxSeo = {
  title: ' النقل',
  meta: {
    description:
      'استفد من خدمات النقل المتطورة لنقل الخضار والفواكه بالجملة إلى وجهتك بسرعة وكفاءة، مع ضمان الحفاظ على جودة المنتجات وفقاً لرؤية 2030.',
  },
}

const routes: Routes = [
  { path: '', component: HomeOneComponent },
  { path: 'partners', component: AlternativeServiceComponent },
  {
    path: 'seller-description',
    component: SellerDescriptionComponent,
    data: { seo: SEO_SELLER },
  },
  {
    path: 'buyer-description',
    component: BuyerDescriptionComponent,
    data: { seo: SEO_BUYER },
  },
  {
    path: 'transporter-description',
    component: TransporterDescriptionComponent,
    data: { seo: SEO_TRANSPORTER },
  },
  { path: 'blog', component: BlogPageComponent, data: { seo: SEO_BLOG } },
  { path: 'join-us', component: JoinUsComponent },
  { path: 'terms-and-conditions', component: RulesComponent },
  { path: 'article', component: BlogDetailsComponent },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
